module.exports = __webpack_public_path__ + "img/fi-pdf.0c1cefcd.svg";